import { NFTItemsFactory } from "../myWalletNFTs/NFTItemsFactory";
import { MyWalletTab } from "./MyWalletTab";
import { NFTBuilding } from "by/gamefactory/web3/nfts/NFTBuilding";
import { IDestroyOptions, Point } from "pixi.js";
import { ScrollNextElement } from "../myWalletNFTs/scrollItems/ScrollNextElement";
import { MyWalletResourcePackage } from "../../resources/MyWalletResourcePackage";
import { WalletTabType } from "../WalletTabType";
import { IInventory } from "../../../../../../web3/models/IInventory";
import { DynamicAssets } from "../../../../../../resources/DynamicAssets";
import { AsyncOperationNotification } from "../../../../common/components/AsyncOperationNotification";
import { NFTScrollItem } from "../myWalletNFTs/scrollItems/NFTScrollItem";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { NFTBuildingScrollItem } from "../myWalletNFTs/scrollItems/NFTBuildingScrollItem";

export class BuildingsTab extends MyWalletTab {
    private readonly myWalletResources: MyWalletResourcePackage;
    private readonly buildingResources: DynamicAssets;
    private readonly nftItemsFactory: NFTItemsFactory;
    private readonly inventory: IInventory;
    private readonly asyncOperationNotification: AsyncOperationNotification;
    private readonly playerModel: IPlayerModel;

    private buildingsNft: ReadonlyArray<NFTBuilding>;
    private buildingScrollItems: Array<NFTScrollItem>;
    private nextBuildingScrollItem: ScrollNextElement;

    public constructor(
        myWalletResources: MyWalletResourcePackage,
        buildingResources: DynamicAssets,
        nftItemsFactory: NFTItemsFactory,
        inventory: IInventory,
        asyncOperationNotification: AsyncOperationNotification,
        playerModel: IPlayerModel
    ) {
        super(true, WalletTabType.BUILDING, {
            elementsWidth: 500,
            elementsMargin: 40,
            scrollPosition: new Point(0, 42)
        });
        this.myWalletResources = myWalletResources;
        this.buildingResources = buildingResources;
        this.nftItemsFactory = nftItemsFactory;
        this.inventory = inventory;
        this.asyncOperationNotification = asyncOperationNotification;
        this.playerModel = playerModel;
        this.buildingsNft = inventory.buildingsNFT;
        this.buildingScrollItems = [];
        this.addScrollItems(this.buildingsNft);
    }

    public async updateBuildings(): Promise<void> {
        if (this.buildingsNft !== this.inventory.buildingsNFT) {
            const asyncOperations: Array<Promise<any>> = [];

            const buildingsToAdd = this.inventory.buildingsNFT.filter((newBuilding) => this.buildingsNft.findIndex((oldBuilding) => newBuilding.id === oldBuilding.id) === -1);
            for (const buildingToAdd of buildingsToAdd) {
                this.buildingResources.add(buildingToAdd.imageURL);
            }
            const buildingsToRemove = this.buildingsNft.filter((oldBuilding) => this.inventory.buildingsNFT.findIndex((newBuilding) => newBuilding.id === oldBuilding.id) === -1);
            if (buildingsToAdd.length !== 0 || buildingsToRemove.length !== 0) {
                this.scrollBox.reset();
            }
            for (const buildingToRemove of buildingsToRemove) {
                const scrollItemIndex = this.buildingScrollItems.findIndex((item) => item.data.id === buildingToRemove.id);
                if (scrollItemIndex !== -1) {
                    asyncOperations.push(this.scrollBox.removeItem(this.buildingScrollItems[scrollItemIndex], true));
                    this.buildingScrollItems[scrollItemIndex].onClick.remove(this.onBuildingClickHandle, this);
                    this.buildingScrollItems.splice(scrollItemIndex, 1);
                }
                this.buildingResources.remove(buildingToRemove.imageURL);
            }
            this.buildingsNft = this.inventory.buildingsNFT;
            if (this.buildingsNft.length > 0 && this.nextBuildingScrollItem != null) {
                this.scrollBox.removeItem(this.nextBuildingScrollItem);
                this.nextBuildingScrollItem = null;
            }
            asyncOperations.push(this.buildingResources.load());
            await this.asyncOperationNotification.autoShowHide(Promise.all(asyncOperations));
            this.addScrollItems(buildingsToAdd);
        }
        this.buildingsNft = this.inventory.buildingsNFT;
    }

    private addScrollItems(items: ReadonlyArray<NFTBuilding>): void {
        for (const nft of items) {
            const buildingModel = this.playerModel.buildings.value.find((buildingModel) => buildingModel.id.value === nft.buildingId);
            if (buildingModel == null) {
                continue;
            }
            const item = this.nftItemsFactory.createItem(nft);
            if (item == null) {
                continue;
            }
            this.scrollBox.addItem(item as NFTBuildingScrollItem);
            (item as NFTBuildingScrollItem).onClick.add(this.onBuildingClickHandle, this);
            this.buildingScrollItems.push(item as NFTBuildingScrollItem);
        }
        if (this.scrollBox.itemsCount === 0 && this.nextBuildingScrollItem == null) {
            this.nextBuildingScrollItem = new ScrollNextElement(this.myWalletResources, WalletTabType.BUILDING);
            this.scrollBox.addItem(this.nextBuildingScrollItem);
        }
    }

    private onBuildingClickHandle(item: NFTScrollItem): void {
        this.onItemClick.emit(WalletTabType.BUILDING, item);
    }

    public updatePointer(): void {
        return;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.scrollBox.items.forEach((building) => building.onClick.remove(this.onBuildingClickHandle, this));
        super.destroy(options);
    }
}
